import axios from "axios";
import settings from "../../../../utils/settings";

const url = `${settings.accountsUrl}api/admin/news`;

export const addPhoto = (id, language, photo) => {
    const formData = new FormData();
    formData.append("language", language);
    formData.append("photo", photo, `photo-${id}-${language}`);
    return axios.post(`${url}/${id}/photo`, formData);
}


// WEBPACK FOOTER //
// ./src/views/pages/news/requests/addPhoto.js